"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDepositHeader = DirectDepositHeader;
exports.DirectDepositAddEditForm = DirectDepositAddEditForm;
exports.default = DirectDepositAddEdit;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const UserContext_1 = require("../contexts/UserContext");
const Button_1 = __importDefault(require("../components/Button"));
const DirectDeposit_1 = __importDefault(require("../api/DirectDeposit"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const Field_1 = __importDefault(require("../components/Field"));
const AuthForms_1 = require("../partials/AuthForms");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const SessionContext_1 = require("../contexts/SessionContext");
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function DirectDepositHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.BuildingColumns, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: '500', fontSize: size != 'sm' ? 18 : 16, marginLeft: 12 }, children: props.text }), !!props.subText && (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, marginLeft: 12 }, children: props.subText })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: 'borderless', onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
function DirectDepositAddEditForm(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const refreshPromise = react_1.default.useRef(null);
    const bannedPromise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState("done");
    const [isConfirming, setIsConfirming] = react_1.default.useState(false);
    const [canSelectRemaining, setCanSelectRemaining] = react_1.default.useState(true);
    const [account, setAccount] = react_1.default.useState({
        transitNumber: "",
        accountNumber: "",
        type: "Checking",
        method: "Fixed",
        amount: 0,
        status: "Pre-notification"
    });
    const [originalAccount, setOriginalAccount] = react_1.default.useState({
        transitNumber: "",
        accountNumber: "",
        type: "Checking",
        method: "Fixed",
        amount: 0,
        status: "Pre-notification"
    });
    const [directDepositList, setDirectDepositList] = react_1.default.useState();
    const [hasChanges, setHasChanges] = react_1.default.useState(false);
    const [bannedBankData, setBannedBankData] = react_1.default.useState(null);
    const [showBannedTransitMessage, setShowBannedTransitMessage] = react_1.default.useState(false);
    const [restrictSubmit, setRestrictSubmit] = react_1.default.useState(false);
    const accountTypes = [
        {
            label: t('myPay:labels.Checking'),
            value: "Checking",
        },
        {
            label: t('myPay:labels.Savings'),
            value: "Savings",
        },
    ];
    const depositMethods = [
        {
            label: t('myPay:labels.fixed'),
            value: "Fixed",
        },
        {
            label: t('myPay:labels.percent'),
            value: "Percentage",
        },
        {
            label: t('myPay:labels.remain'),
            value: "Remaining",
            disabled: !canSelectRemaining
        },
    ];
    const adding = props.index == undefined;
    const save = react_1.default.useCallback((data, deleting) => {
        if (deleting) {
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                'feature': 'Delete Direct Deposit',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId
            });
        }
        else if (adding) {
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                'feature': 'Add Direct Deposit',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId
            });
        }
        else {
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                'feature': 'Edit Direct Deposit',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId
            });
        }
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => DirectDeposit_1.default.update(token, data)))
            .then(() => {
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "success", message: t('myPay:messages.ddSave') });
            react_native_1.DeviceEventEmitter.emit("event.directDepositUpdate");
        })
            .catch(() => {
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('myPay:messages.ddFail') });
        })
            .finally(() => {
            props.onSaved();
        });
    }, []);
    const refresh = react_1.default.useCallback(() => {
        refreshPromise?.current?.cancel();
        bannedPromise?.current?.cancel();
        setStatus('loading');
        refreshPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => DirectDeposit_1.default.getList(token)))
            .then((data) => {
            let remainingEnabled = true;
            if (data?.accounts?.length > 0) {
                data.accounts = data?.accounts?.filter(x => x.status != 'Deposit Inactive') ?? [];
                remainingEnabled = data.accounts.some((account) => account.method == 'Remaining' && account.status != 'Deposit Inactive') == false;
                setCanSelectRemaining(remainingEnabled);
            }
            setDirectDepositList(data);
            if (!adding && data.accounts[props.index]) {
                setAccount(data.accounts[props.index]);
                setOriginalAccount(data.accounts[props.index]);
                react_native_1.DeviceEventEmitter.emit("event.bankNameLoaded", { bankName: data.accounts[props.index].bankName });
            }
            else if (adding) {
                const newAccount = {
                    transitNumber: "",
                    accountNumber: "",
                    type: "Checking",
                    method: remainingEnabled ? 'Remaining' : 'Fixed',
                    amount: 0,
                    status: 'Pre-notification'
                };
                setAccount(newAccount);
                setOriginalAccount(newAccount);
            }
            bannedPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => DirectDeposit_1.default.getBanned(token)))
                .then((bannedData) => {
                setBannedBankData(bannedData.transitNumbers ?? []);
            })
                .catch(() => {
                console.error("Failed to fetch banned bank data");
                setBannedBankData(null);
            });
            setStatus('done');
        })
            .catch(() => {
            setStatus('error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
            refreshPromise.current?.cancel();
            react_native_1.DeviceEventEmitter.removeAllListeners("event.directDepositUpdate");
        };
    }, []);
    const showConfirmation = () => {
        if (bannedBankData && bannedBankData.includes(account.transitNumber)) {
            setShowBannedTransitMessage(true);
            setRestrictSubmit(true);
            FirebaseAnalytics_1.default.LogEvent('attention_area', {
                'area': 'Banned Bank Information',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId
            });
            return;
        }
        setIsConfirming(true);
    };
    const upsertAccount = () => {
        if (props.index >= 0) {
            directDepositList.accounts[props.index] = account;
        }
        else {
            directDepositList.accounts.push(account);
        }
        save(directDepositList, false);
    };
    const deleteAccount = () => {
        if (!adding && directDepositList?.accounts?.length > 1) {
            // Set account to inactive (soft delete)
            let account = directDepositList.accounts[props.index];
            account.status = 'Deposit Inactive';
            directDepositList.accounts[props.index] = account;
            save(directDepositList, true);
        }
    };
    const valid = account?.transitNumber && account?.accountNumber && (account?.method == 'Remaining' || account?.amount > 0);
    const maxPercent = 99 - (props.otherPercent ?? 0);
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (status == 'done' && ((0, jsx_runtime_1.jsxs)(FadeInView_1.default, { children: [showBannedTransitMessage && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 6 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": t('myPay:hints.bannedTransit'), style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12 }, children: t('myPay:text.bannedTransit') }) })), (isConfirming && !showBannedTransitMessage)
                    &&
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 6 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": t('myPay:hints.ddTerms'), style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12 }, children: t('myPay:text.ddTerms') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12 }, children: t('myPay:text.ddTerms2') }) })] })
                    ||
                        (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !showBannedTransitMessage &&
                                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [adding &&
                                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('myPay:labels.transNum'), dense: true, style: STYLES.input, label: t('myPay:labels.transNum'), disabled: !adding, value: account.transitNumber ?? '', mode: 'outlined', inputMode: 'numeric', maxLength: 9, onChangeText: (value) => {
                                                            let transitNum = value.replace(/[^0-9]/g, '');
                                                            setAccount({ ...account, transitNumber: transitNum });
                                                            props?.onIsChanged();
                                                            if (!hasChanges) {
                                                                setHasChanges(transitNum != originalAccount.transitNumber);
                                                            }
                                                        } }), (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { dense: true, style: [STYLES.input, { marginTop: 12 }], label: t('myPay:labels.accNum'), disabled: !adding, value: account.accountNumber ?? '', mode: 'outlined', inputMode: 'numeric', "aria-label": t('myPay:labels.accNum'), onChangeText: (value) => {
                                                            let accNum = value.replace(/[^0-9]/g, '');
                                                            setAccount({ ...account, accountNumber: accNum });
                                                            props?.onIsChanged();
                                                            if (!hasChanges) {
                                                                setHasChanges(accNum != originalAccount.accountNumber);
                                                            }
                                                        } })] })
                                            ||
                                                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:labels.transNum'), value: account.transitNumber }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:labels.accNum'), value: account.accountNumber }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator, { marginTop: 6 }] })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: accountTypes, label: t('myPay:labels.accType'), setValue: (value) => {
                                                    setAccount({ ...account, type: value });
                                                    props?.onIsChanged();
                                                    if (!hasChanges) {
                                                        setHasChanges(originalAccount.type != value);
                                                    }
                                                }, value: account.type }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: depositMethods, label: t('myPay:text.amt'), setValue: (value) => {
                                                    setAccount({ ...account, method: value, amount: 0 });
                                                    props?.onIsChanged();
                                                    if (!hasChanges) {
                                                        setHasChanges(originalAccount.method != value);
                                                    }
                                                }, value: account.method }) }), account.method == 'Fixed' && ((0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { dense: true, style: [STYLES.input, { marginTop: 12 }], value: account.amount?.toString() ?? "", label: t('myPay:labels.fixAmt') + ' ($)', mode: 'outlined', inputMode: 'numeric', accessibilityHint: t('myPay:labels.fixAmt'), onChangeText: (text) => {
                                                let amt = parseFloat(Helper_1.Helper.MaskCurrency(text)) || 0;
                                                setAccount({ ...account, amount: amt });
                                                if (!hasChanges) {
                                                    setHasChanges(originalAccount.amount != amt);
                                                }
                                            } })), account.method == 'Percentage' && ((0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { dense: true, style: [STYLES.input, { marginTop: 12 }], value: account.amount?.toString() ?? "", label: t('myPay:text.amt') + ' (%)', mode: 'outlined', inputMode: 'numeric', accessibilityHint: t('myPay:labels.percent'), onChangeText: (text) => {
                                                text = Helper_1.Helper.MaskCurrency(text);
                                                let value = Math.min(parseFloat(text) || 0, maxPercent);
                                                setAccount({ ...account, amount: value });
                                                if (!hasChanges) {
                                                    setHasChanges(originalAccount.amount != value);
                                                }
                                            } }))] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { justifyContent: 'flex-end' }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 18 }, children: [!adding && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginRight: 12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.del'), type: 'outline', color: THEME.Red, onPress: () => deleteAccount() }) })), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(restrictSubmit && !isConfirming) &&
                                        (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.continue'), type: 'solid', color: THEME.PrimaryDark, onPress: () => props?.navigation?.goBack() }), !restrictSubmit &&
                                        (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: adding &&
                                                (0, jsx_runtime_1.jsx)(Button_1.default, { text: isConfirming ? t('common:buttons.confirm') : t('common:buttons.continue'), disabled: !valid, type: 'solid', color: THEME.PrimaryDark, onPress: (isConfirming && !restrictSubmit) ? () => upsertAccount() : () => showConfirmation() })
                                                ||
                                                    (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.save'), disabled: !valid || !hasChanges, type: 'solid', onPress: () => upsertAccount() }) })] })] }) })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == "loading" }) }));
}
function DirectDepositAddEdit(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const sessionContext = react_1.default.useContext(SessionContext_1.SessionContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [isChanged, setIsChanged] = react_1.default.useState(false);
    const [isConfirming, setIsConfirming] = react_1.default.useState(false);
    const onClose = () => {
        if (isChanged) {
            setIsConfirming(true);
        }
        else {
            props.navigation.goBack();
        }
    };
    const [step, setStep] = react_1.default.useState('editing');
    const [bankName, setBankName] = react_1.default.useState("");
    react_native_1.DeviceEventEmitter.addListener("event.bankNameLoaded", (eventData) => onBankNameLoaded(eventData));
    const onBankNameLoaded = (result) => {
        setBankName(result?.bankName ?? "");
    };
    react_1.default.useEffect(() => {
        const timeSinceAuth = sessionContext.getTimeSinceAuth();
        if (timeSinceAuth == null || timeSinceAuth?.total?.minutes > 15) {
            setStep('authenticate');
        }
        return () => react_native_1.DeviceEventEmitter.removeAllListeners("event.bankNameLoaded");
    }, []);
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, needsConfirmation: isChanged, onConfirmation: () => setIsConfirming(true), children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsx)(DirectDepositHeader, { text: t('myPay:text.ddAcc'), subText: bankName, onClose: onClose }) }), (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: 'handled', children: [isConfirming &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginBottom: 12, backgroundColor: THEME.UltraLightGray, borderRadius: 4, flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 6, borderBottomLeftRadius: 4, borderTopLeftRadius: 4, backgroundColor: THEME.Red } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12, flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, fontWeight: '500', paddingVertical: 1 }, children: t('common:text.sure') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, paddingVertical: 1 }, children: t('common:text.sureDescription') })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', text: t('common:buttons.back'), onPress: () => setIsConfirming(false) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.discard'), onPress: () => props.navigation.goBack() }) })] })] }), (step == 'authenticate') &&
                        (0, jsx_runtime_1.jsx)(AuthForms_1.AuthReauthenticate, { allowGoogle: true, onCancel: props.navigation.goBack, onSuccess: () => { setStep('editing'); } }), (step == 'editing') &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { display: isConfirming ? 'none' : undefined }, children: (0, jsx_runtime_1.jsx)(DirectDepositAddEditForm, { index: props.route.params?.index ?? undefined, otherPercent: props.route.params?.otherPercent ?? 0, navigation: props.navigation, onSaved: props.navigation.goBack, onIsChanged: () => setIsChanged(true) }) })] })] }));
}
